import { Box } from '@mui/material';
import React, { useState, useEffect } from 'react';
import DataGrid from 'react-data-grid';
import { textEditor } from 'react-data-grid';

/**
 * This is a version of the data grid that has fixed
 * columns and is more controlled than the flexible
 * ones we will use in the block composer. 
 * 
 * @param {*} param0 
 * @returns 
 */
export const BlockDataGrid = ({ onDataChange, columnNames = ["Dark", "Reference", "Signal"] }) => {
  // Create blank rows with dynamic columns
  const blankRows = Array(10).fill({}).map((_, index) => ({
    id: index + 1,
    ...columnNames.reduce((acc, col) => ({ ...acc, [col]: "" }), {})
  }));

  // Create columns from provided names
  const [columns, setColumns] = useState(
    columnNames.map(name => ({
      key: name,
      name: name,
      editable: true,
      renderEditCell: textEditor
    }))
  );

  const [rows, setRows] = useState(blankRows);

  // Handle cell editing
  const handleRowsChange = (newRows) => {
    setRows(newRows);
    // Notify parent component of data changes
    onDataChange(newRows);
  };

  const handlePaste = (event) => {
    console.log(event.clipboardData.getData("text"));
    event.preventDefault();
    const clipboardData = event.clipboardData.getData("text");
    const rows = clipboardData.trim().split("\n").map((row) => row.split("\t").map((cell) => cell.trim()));

    if (rows.length > 0) {
      const minRows = 6;

      const newData = rows.map((row, rowIndex) => {
        let rowData = { id: rowIndex + 1 };
        for (let i = 0; i < columnNames.length; i++) {
          rowData[columnNames[i]] = row[i] || "";
        }
        return rowData;
      });
/*
      while (newData.length < minRows) {
        let emptyRow = { id: newData.length + 1 };
        for (let i = 0; i < columnNames.length; i++) {
          emptyRow[`col${i}`] = "";
        }
        newData.push(emptyRow);
      }*/
      console.log(newData);
      setRows(newData);
      onDataChange(newData);
    }
  };

  return (
    <div style={{ width: '100%' }} >
      <Box onPaste={handlePaste}>
      <DataGrid
        rows={rows}
        columns={columns}
        onRowsChange={handleRowsChange}
        style={{ height: 300 }}
      />
      </Box>
    </div>
  );
};
